import { useLegislativeAlerts } from "@/hooks/use-legislative-alerts";

export function LegislativeAlertsProvider() {
  useLegislativeAlerts();
  return null;
}
